import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { IConditionItem } from "interfaces"
import { Link } from "react-router-dom"
import { isHaveActionPermission } from "utills/helpers";

interface ConditionCardProps {
  data?: IConditionItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const ConditionCard = ({data = [], pageSize, currentPage, _toggleActive }: ConditionCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((condition: IConditionItem, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <div>
              <SwitchButton
                checked={condition.is_active}
                disabled={
                  !isHaveActionPermission("about_actiup", "other", "edit")
                }
                onChange={() =>
                  _toggleActive(condition.id, condition.is_active)
                }
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <Link to={`/other/about-actiup/${condition.id}`} className="w-fit">
                <span className="sr-only">View Condition</span>
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("about_actiup", "other", "edit") ? (
                <Link
                  to={`/other/about-actiup/${condition.id}/edit`}
                  className="w-fit"
                >
                  <span className="sr-only">Edit Condition</span>
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Title (en)
            </p>
            <p className="flex-1 text-right text-sm leading-6">{condition.title_en}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Title (en)
            </p>
            <p className="flex-1 text-right text-sm leading-6">{condition.title_en}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Title (vi)
            </p>
            <p className="flex-1 text-right text-sm leading-6">{condition.title_vi}</p>
          </li>
        </div>
      ))}
    </ul>
  )
}